import React from 'react';
const MandatoryLabel = (props) => {
    return (
        <label style={{color:"red"}}> * </label>
    );
};

export default MandatoryLabel;
